import right from "../../assets/images/right.png";
import ProductCard from "./ProductCard";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Custom Arrow Components accepting sliderId via props
const NextArrow = ({ onClick, sliderId }) => (
  <div className={`custom-arrow next arrow-${sliderId}`} onClick={onClick}>
    <img src={right} alt="Next" />
  </div>
);

const PrevArrow = ({ onClick, sliderId }) => (
  <div className={`custom-arrow prev arrow-${sliderId}`} onClick={onClick}>
    <img src={right} alt="Previous" />
  </div>
);

const GaonNear = ({ title, data, sliderId }) => {
  const totalPlaces = data?.places?.length || 0;
  const showArrows = totalPlaces > 4;

  const settings = {
    dots: false,
    arrows: showArrows,
    infinite: showArrows,
    initialSlide: 0,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2.1 },
      },
    ],
    nextArrow: showArrows ? <NextArrow sliderId={sliderId} /> : null,
    prevArrow: showArrows ? <PrevArrow sliderId={sliderId} /> : null,
  };

  return (
    <section className={`product_section ${data?.places?.length > settings.slidesToShow ? "pd_section" : ""}`}>
      <div className="max_container">
        <div className="product_sec_head">
          <div className="product_sec_ttl">{title}</div>
        </div>
        <div className="product_container">
          <div className="product_cards">
            <Slider key={`slider-${sliderId}`} {...settings}>
              {data?.places?.map((d, index) => (
                <div key={index}>
                  <ProductCard
                    img={d?.assets?.url}
                    name={d?.name}
                    open={d?.time}
                    distance={d?.radius}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GaonNear;
